import ContentFolderListing from '@/components/content-folder-listing';
import { SeoMeta } from '@/components/seo-meta';
import type { PageWithComponentData } from 'src/lib/page-designer/page-loader.server';
import type { FolderListingRouteData, NewsListingRouteData } from './types';

export function FolderListingRoute({
    data,
    page,
    kind,
}: {
    data: FolderListingRouteData | NewsListingRouteData;
    page?: PageWithComponentData;
    kind: 'folderListing' | 'newsListing';
}) {
    return (
        <>
            <SeoMeta
                pageMetaTags={data.criticalSearchResult.pageMetaTags}
                pageTitle={data.folder.pageTitle}
                pageDescription={data.folder.pageDescription}
                title={data.folder.title}
                prevUrl={data.paginationPrevUrl ?? undefined}
                nextUrl={data.paginationNextUrl ?? undefined}
                noIndexFollow={data.currentPage > 1}
                indexFollow={data.currentPage === 1}
                description={data.folder.description || undefined}
                openGraph={{
                    type: 'website',
                    url: data.pageUrl,
                }}
            />
            <ContentFolderListing
                page={page}
                kind={kind}
                folder={data.folder}
                criticalSearchResult={data.criticalSearchResult}
                nonCriticalSearchResult={data.nonCriticalSearchResult}
                subCategoryLinks={data.subCategoryLinks}
                currentPage={data.currentPage}
                limit={data.limit}
                initialOrdinationOpen={data.initialOrdinationOpen}
                sortingOptionIds={data.sortingOptionIds}
            />
        </>
    );
}
